import en from './en.json';
import fr from './fr.json';

export const activationI18n = {
  fr,
  en,
};
